<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.75 3.625C3.40482 3.625 3.125 3.90482 3.125 4.25V16.75C3.125 17.0952 3.40482 17.375 3.75 17.375H16.25C16.5952 17.375 16.875 17.0952 16.875 16.75V4.25C16.875 3.90482 16.5952 3.625 16.25 3.625H3.75ZM1.875 4.25C1.875 3.21447 2.71447 2.375 3.75 2.375H16.25C17.2855 2.375 18.125 3.21447 18.125 4.25V16.75C18.125 17.7855 17.2855 18.625 16.25 18.625H3.75C2.71447 18.625 1.875 17.7855 1.875 16.75V4.25Z"
      fill="#D9D9D9"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.66666 2.375C7.01184 2.375 7.29166 2.65483 7.29166 3V18C7.29166 18.3452 7.01184 18.625 6.66666 18.625C6.32149 18.625 6.04166 18.3452 6.04166 18V3C6.04166 2.65483 6.32149 2.375 6.66666 2.375Z"
      fill="#D9D9D9"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.79166 18C4.79166 17.6548 5.07149 17.375 5.41666 17.375H7.91666C8.26184 17.375 8.54166 17.6548 8.54166 18C8.54166 18.3452 8.26184 18.625 7.91666 18.625H5.41666C5.07149 18.625 4.79166 18.3452 4.79166 18Z"
      fill="#D9D9D9"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.79166 3C4.79166 2.65483 5.07149 2.375 5.41666 2.375H7.91666C8.26184 2.375 8.54166 2.65483 8.54166 3C8.54166 3.34517 8.26184 3.625 7.91666 3.625H5.41666C5.07149 3.625 4.79166 3.34517 4.79166 3Z"
      fill="#D9D9D9"
    />
  </svg>
</template>
